module.exports = __webpack_public_path__ + "img/traitement6.a49b3604.jpg";